export class NotificationModel {
    Message?: string
    Link?: string
    ImageUrl?: string
};